import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { Task, AddTask, DetailTask, DuplicateTask, EditTask } from "./pages";

const taskRoutes = [
  {
    path: "/task",
    element: (
      <ProtectedRoute name="task">
        <Task />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="task" defaultTitle="task.title" />
    ),
    children: [
      {
        path: "/task/add",
        element: (
          <ProtectedRoute name="task_add">
            <AddTask />
          </ProtectedRoute>
        ),
        breadcrumb: () => <TranslationBreadcrumb name="task.add_task" />,
      },
    ],
  },
  {
    path: "/task/detail/:id",
    element: (
      <ProtectedRoute name="task">
        <DetailTask />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="task.detail" />,
    children: [
      {
        path: "/task/detail/:id/duplicate",
        element: (
          <ProtectedRoute name="task_add">
            <DuplicateTask />
          </ProtectedRoute>
        ),
        breadcrumb: () => <TranslationBreadcrumb name="task.duplicate_task" />,
      },
      {
        path: "/task/detail/:id/edit",
        element: (
          <ProtectedRoute name="task_edit">
            <EditTask />
          </ProtectedRoute>
        ),
        breadcrumb: () => <TranslationBreadcrumb name="task.edit_task" />,
      },
    ],
  },
];

export default taskRoutes;
